
/**
 * 测试短信发送记录公共弹窗
 * @param smsTestType-短信类型 1.催付 2.画布，默认传0
 */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Button, DatePicker, Form, Input, Select, Table } from '@alifd/next';
import LzPagination from '@/components/common/LzPagination';
import LzMsg from '@/components/common/LzMsg';
import LzTag from '@/components/common/LzTag';
import styles from './index.module.scss';
import { Servlets } from '@/service';
import utils from '@/common/utils';

// 测试短信发送状态
const sendStatus = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '投递成功',
    value: 1,
  },
  {
    label: '发送中',
    value: 0,
  },
  {
    label: '投递失败',
    value: 2,
  },
];

function TestSendDetail({ smsTestType = 0, startTime = '', endTime = '' }) {
  const [isLoading, setLoading] = useState(false);
  const [showDesc, setShowDesc] = useState(false);
  // form查询条件
  const [formValues, setFormValues] = useState({
    startTime,
    endTime,
    receivePhone: '',
    sendResult: '',
  });

  // 分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });

  const [tabledata, setTableData] = useState([]);

  // 选择时间
  // const changeTime = (val) => {
  //   let startT;
  //   let endT;
  //   startT = val[0] ? moment(val[0]).unix() : '';
  //   endT = val[1] ?  moment(val[1]).unix() : '';
  //   setFormValues({ ...formValues, startTime: startT, endTime:endT});
  // };
  const changeTime = (val) => {
    let startT;
    let endT;
    startT = val[0] ? moment(val[0]).format('YYYY-MM-DD') : '';
    endT = val[1] ? moment(val[1]).format('YYYY-MM-DD') : '';
    setFormValues({ ...formValues, startTime: startT, endTime: endT });
  };
  /**
   * 重置筛选数据
   */
  const resetFilter = () => {
    setFormValues({
      ...formValues,
      startTime: '',
      endTime: '',
      receivePhone: '',
      sendResult: '',
    });
    searchList({
      pageNo: 1,
      pageSize: pageInfo.pageSize,
      startTime: '',
      endTime: '',
      receivePhone: '',
      sendResult: '',
    });
  };

  /**
   * 查询测试短信列表记录
   */
  const searchList = (v) => {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
    if (formValues.receivePhone && !reg.test(formValues.receivePhone)) {
      LzMsg.warning('请输入正确的手机号');
      return;
    }
    setLoading(true);
    const params = {
      functionType: 3,
      smsTaskType: 1,
      startTime: formValues.startTime ? new Date(`${formValues.startTime} 00:00:00`).getTime() : '',
      endTime: formValues.endTime ? new Date(`${formValues.endTime} 23:59:59`).getTime() : '',
      receivePhone: formValues.receivePhone ? Number(formValues.receivePhone) : '',
      sendResult: formValues.sendResult,
      pageNo: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
      // smsTestType,
      ...v,
    };
    Servlets('getConsumptionDetail', params).then((res) => {
      if(res.success) {
        setTableData(res.data);
        setPageInfo({
          ...pageInfo,
          pageNo: res.page?.pageNo || pageInfo.pageNo,
          pageSize: res.page?.pageSize || pageInfo.pageSize,
          total: res.page.total,
        });
        setLoading(false);
      } else {
        LzMsg.error(res.resp_msg);
      }
    }).catch((e) => {
      setLoading(false);
    });
  };

  /**
   * 刷新短信状态
   */
  const refresh = (id) => {
    Servlets('getTestSmsStatus', { id }).then((res) => {
      if (res?.data) {
        searchList();
      }
    }).catch((e) => {
      console.log(e);
    });
  };

  /**
   * 翻页方法
   */
  const handlePageSizeChange = async (pages = {}) => {
    setLoading(true);
    try {
      searchList({ pageNo: pages.pageNo, pageSize: pages.pageSize });
    } catch (e) {
      setLoading(false);
      LzMsg.error(e.message);
    }
  };

  /**
   * 导出exl
   */
  const exportExl = () => {
    if (tabledata.length) {
      Servlets('exportConsumptionDetail', {
        functionType: 3,
        smsTaskType: 1,
        startTime: formValues.startTime ? new Date(`${formValues.startTime} 00:00:00`).getTime() : '',
        endTime: formValues.endTime ? new Date(`${formValues.endTime} 23:59:59`).getTime() : '',
        receivePhone: formValues.receivePhone ? Number(formValues.receivePhone) : '',
        sendResult: formValues.sendResult ? Number(formValues.sendResult) : '',
        pageNo: pageInfo.pageNo,
        pageSize: pageInfo.pageSize,
        // smsTestType,
      })
      .then((res)=>{
        utils.downloadFile(res);
      })
    } else {
      LzMsg.error('数据为空，请切换查询条件后重试');
    }
  };

  useEffect(() => {
    searchList();
  }, []);

  return (
    <div>
      <Form>
        <div  className={styles['search-big-box']}>
          <div className={styles['search-box']}>
            <span>发送时间：</span>
            <Form.Item>
              <DatePicker.RangePicker
                style={{ width: '256px' }}
                value={[formValues.startTime, formValues.endTime]}
                onChange={changeTime}
              />
            </Form.Item>
          </div>
          <div className={styles['search-box']}>
            <span>手机号：</span>
            <Form.Item>
              <Input
                hasClear
                style={{ width: '256px' }}
                placeholder="请输入接收短信手机号"
                name="receivePhone"
                value={formValues.receivePhone}
                onChange={(val) => setFormValues({ ...formValues, receivePhone: val })}
              />
            </Form.Item>
          </div>
          <div className={styles['search-box']}>
            <span>发送状态：</span>
            <Form.Item>
              <Select
                style={{ width: '256px' }}
                hasClear
                followTrigger
                value={formValues.sendResult}
                onChange={(val) => setFormValues({ ...formValues, sendResult: val })}
              >
                {
                  sendStatus.map((i, index) => (
                    <Select.Option
                      value={i.value}
                      key={i.label}
                    >
                      {i.label}
                    </Select.Option>
                  ))
                }
              </Select>
            </Form.Item>
          </div>
        </div>
      </Form>
      <div className={styles['search-box1']}>
        <Button
          type="primary"
          className={`${styles.mr10} ${styles.w88}`}
          onClick={() => searchList({ pageNo: 1, pageSize: pageInfo.pageSize })}
        >查询
        </Button>
        <Button type="normal" className={`${styles.mr10} ${styles.w88}`} onClick={resetFilter}>重置</Button>
        <Button type="normal" className={styles.w88} onClick={exportExl}>导出</Button>
      </div>
      <div style={{ color: '#333333', fontSize: '12px', margin: '15px 0' }}>
        <span
          className={'iconfont icon-icon4-38'}
          style={{
            color: '#3399ff',
            marginRight: '5px',
          }}
        /><span>注：当状态为投递成功且未收到测试短信时，建议客户按如下方式，逐一排查下手机客户端是否存在以下问题：</span><Button
          className="table-cell-btn"
          type="primary"
          text
          style={{ fontSize: 12 }}
          onClick={() => (showDesc ? setShowDesc(false) : setShowDesc(true))}
        >{showDesc ? '收起详情' : '展开详情'}
        </Button>
        {
          showDesc && <div style={{ textIndent: '2em', lineHeight: '1.9', color: '#657180' }}>
            <div>1、检查手机是否有安装拦截软件，是否被拦截软件拦截进入黑名单或者垃圾箱；</div>
            <div>2、手机是否长时间未关机，也会影响信息接收不稳定，建议关机重启看下；</div>
            <div>3、建议排查短信箱是否有满，如接收信息过多，建议及时删除短信关机重启再测试，查看是否可以收到；</div>
            <div>4、建议排查用户所在地区信号是否稳定，如下发时段信号不稳定无法及时响应可能会接收不到或滞后接收的情况；</div>
            <div>5、用户是否使用双卡双待手机，双卡双待手机也会影响接收信息，接收不稳定时可以换卡槽试试；</div>
            <div>6、建议将自己手机卡放到其他手机上再下发条信息测试，看是否可以正常收到。</div>
          </div>
        }
      </div>
      <Table
        loading={isLoading}
        dataSource={tabledata}
        fixedHeader
        maxBodyHeight={(window.screen.height) * 0.6 - 180}
      >
        <Table.Column
          title="发送时间"
          key="sendTime"
          dataIndex='sendTime'
        />
        <Table.Column title="手机号" dataIndex="receivePhone" key="receivePhone" />
        <Table.Column title="短信内容" dataIndex="fullContent" key="fullContent" />
        <Table.Column
          title="字数/计费（条）"
          key="smsNum"
          cell={(value, index, item) => (
            <span
            >{item.smsSplitNum}
            </span>
          )}
        />
        <Table.Column
          title="发送状态"
          key="sendResult"
          cell={(value, index, item) =>
            (<span style={{ display: 'inline-block' }}>
              {item.sendResult === 1 ? <LzTag.Success shadow>投递成功</LzTag.Success> : item.sendResult === 2 ?
                <LzTag.Error shadow>投递失败</LzTag.Error> : <><LzTag.Text shadow>发送中...</LzTag.Text>
                  <span className={styles.globalLink} onClick={() => refresh(item.id)}>刷新</span>
                </>}
             </span>
            )}
        />
        <Table.Column
          title="备注"
          key="errorMessage"
          cell={(value, index, item) => (
            <span style={{ display: 'inline-block' }}>{item.errorMessage || '--'}</span>
          )}
        />
      </Table>
      <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
    </div>
  );
}

export default TestSendDetail;
